import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { selectChangeStatusDelay, selectCreateCouponIsLoadingV2 } from '@mwl/core-lib';
import CouponBetsIcon from '@public/assets/common/icons/betsHistory.svg';
import CouponIcon from '@public/assets/common/icons/coupon.svg';
import type { ButtonAsButton } from '@/components/Button/Button';
import { Button } from '@/components/Button/Button';
import { useTypedSelector } from '@/hooks';
import type { CouponTabsProps } from './CouponTabs.types';
import styles from './CouponTabs.module.scss';
const tabProps: Omit<ButtonAsButton, 'children'> = {
  as: 'button',
  size: 'md',
  color: 'red',
  variant: 'outlined'
};
const CouponTabs: FC<CouponTabsProps> = ({
  tabState,
  setTabState,
  betsCount,
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const statusDelay = useTypedSelector(selectChangeStatusDelay);
  const isCouponLoading = useTypedSelector(selectCreateCouponIsLoadingV2);
  const globalDisabled = !!statusDelay || isCouponLoading;
  return <div className={cn(styles.root, className)} data-sentry-component="CouponTabs" data-sentry-source-file="CouponTabs.tsx">
      <Button {...tabProps} className={cn(styles.tab, {
      [styles.active]: tabState.active === 'coupon',
      [styles.disabled]: tabState.disabled === 'coupon'
    })} onClick={() => setTabState({
      ...tabState,
      active: 'coupon'
    })} active={tabState.active === 'coupon'} variant={tabState.active === 'coupon' ? 'lined' : 'text'} disabled={tabState.disabled === 'coupon' || globalDisabled} data-sentry-element="Button" data-sentry-source-file="CouponTabs.tsx">
        <div className={styles.tabContent}>
          <span>
            <CouponIcon className={styles.icon} width={16} height={16} data-sentry-element="CouponIcon" data-sentry-source-file="CouponTabs.tsx" />
          </span>
          <span className={styles.tabText}>{t('coupon.tab.coupon', 'Coupon')}</span>
        </div>
      </Button>

      <Button {...tabProps} className={cn(styles.tab, {
      [styles.active]: tabState.active === 'bets',
      [styles.disabled]: tabState.disabled === 'bets'
    })} onClick={() => setTabState({
      ...tabState,
      active: 'bets'
    })} active={tabState.active === 'bets'} variant={tabState.active === 'bets' ? 'lined' : 'text'} disabled={tabState.disabled === 'bets' || globalDisabled} data-sentry-element="Button" data-sentry-source-file="CouponTabs.tsx">
        <div className={styles.tabContent}>
          <span>
            <CouponBetsIcon className={styles.icon} width={20} height={20} data-sentry-element="CouponBetsIcon" data-sentry-source-file="CouponTabs.tsx" />
          </span>
          <span className={styles.tabText}>{t('coupon.tab.bets', 'My bets')}</span>
          {!!betsCount && <span className={styles.badge}>{betsCount}</span>}
        </div>
      </Button>
    </div>;
};
export { CouponTabs };